module.exports = __webpack_public_path__ + "img/nutrien-logo.f566fb17.jpg";